import { Button, Loader } from '@scuf/common';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getBudgetPDF } from 'resources/api/repaircenter_api/getBudgetPDF';
import 'styles/main.scss';
import PrintHeader from '../../../printHeaderManufacturing';

const PrintOrder: React.FC = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);

    async function printContent(osID: any, rmaId: any) {
        try {
            setLoading(true);

            const resp = await getBudgetPDF(osID, 4);
            setLoading(false);
            if (resp.error) {
                return alert(resp.message);
            } setLoading(false);
            const WinPrint = window.open('PRINT', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinPrint?.document.write(resp.data);
            setTimeout(
                function () {
                    WinPrint?.print();
                }.bind,
                1000
            );
        } catch (Err) {
            setLoading(false);
            return alert(
                t('common:errors.GeneratePDF')
            );
        }
    }

    return (
        <>
            <PrintHeader title={t('TechnicalAdvice')}></PrintHeader>
            {loading ? (
                <Loader text={t('common:Loading')} />
            ) : (
                <>
                    <Button type="inline" onClick={() => printContent(19397, 122)}></Button>
                </>
            )}
        </>
    );
};

export default PrintOrder;
